

























import { Vue } from "vue-property-decorator";
import type { log } from "@/@types/invest/invest"
import Info from "./info.vue"

export default Vue.extend({
  name : "Logs",
  components: { Info },
  data() {
    return {
      id     : "",
      op     : "",
      data   : [] as log[],
      columns: [
        { dataIndex: "index", title: "序号", align: "center", width: 80, customRender: (text: any, row: any, index: number) => index + 1 },
        { dataIndex: "submit", title: "提交人员", width: 120 },
        { dataIndex: "submit_at", title: "提交时间", width: 120 },
        { dataIndex: "name", title: "场馆名称", width: 120 },
        { dataIndex: "area", title: "省市区", width: 120 },
        { dataIndex: "type", title: "审核类型", width: 120, scopedSlots: { customRender: "type" } },
        { dataIndex: "audit", title: "审核人员", width: 120 },
        { dataIndex: "audit_at", title: "审核时间", width: 120 },
        { title: "审核结果", width: 120, scopedSlots: { customRender: "content" } },
        { dataIndex: "id", title: "操作", width: 120, scopedSlots: { customRender: "action" } },
      ],
      pagination: {
        position       : "both",
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ["10", "100", "1000", "5000", "10000"],
        showTotal      : (total: number) => `总计 ${total} 条记录`
      },
      types: [
        "投资评估审核",
        "合作信息纠错",
        "营业信息纠错"
      ]
    }
  },
  methods: {
    back() {
      this.$router.push({ path: '/invest/stadium_detail', query: { id: this.id } })
    },
    async search() {
      const params = { estimate_id: this.id, op: this.op }
      const res = await this.$store.dispatch("invest_log/correct", params);
      if (res.Code == 200) {
        this.data = res.Data
      }
    },
    info(id: number) {
      this.$nextTick(() => {
        const info = this.$refs.info as any
        info.open(id)
      })
    }
  },
  mounted() {
    const query = { ...this.$route.query };
    if (query.id != "") {
      this.id = query.id as string;
    }
    if (query.op) {
      this.op = query.op as string;
    }
    this.data = []
    this.search()
  }
})

